import React from 'react';
import { TabMenuContainer, MenuItem } from './TabMenu.Styled';

const TabMenu = (props) => {
    return (
        <>
            <TabMenuContainer>
                {props.tabList.map((tab) => (
                    <MenuItem
                     id={`home-calendarpanel-tabmenu-${tab.id}-menu-item`}
                        selected={props.selectedTab.match(tab.id)}
                        onClick={() => props.selectTab(tab.id)}
                        key={tab.id}
                    >
                        {tab.displayName}
                    </MenuItem>
                ))}
            </TabMenuContainer>
        </>
    );
};
export default TabMenu;
